export function getPathname() {
  // SSR対応
  if (typeof window === 'undefined') {
    return '';
  }
  return window.location.pathname;
}
